module.exports = __webpack_public_path__ + "static/media/india_n.a6e897a3.png";